import { render } from "./ReportTemplateSettings.vue?vue&type=template&id=f489fc24&scoped=true"
import script from "./ReportTemplateSettings.vue?vue&type=script&lang=js"
export * from "./ReportTemplateSettings.vue?vue&type=script&lang=js"

import "./ReportTemplateSettings.vue?vue&type=style&index=0&id=f489fc24&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f489fc24"]])

export default __exports__